module.exports = {
    maritalStatus: {
        U: 'Single',
        M: 'Married',
        W: 'Widowed',
        S: 'Separated',
        D: 'Divorced'
    },
    sourceOfFunds: {
        A: 'Allowance',
        B: 'Business',
        C: 'Commission',
        D: 'Donations/Contributions & the like',
        E: 'Economically Inactive Client (student/housewife/unemployed)',
        F: 'Campaign Funds',
        I: 'Interest on Savings/Placements/Investments',
        O: 'Others',
        P: 'Pension',
        S: 'Salary'
    },
    employerBusinessNature: {
        ACT: 'Accounting / Bookkeeping / Tax Practice / Services',
        ADS: 'Advertising / Marketing / Sales Activities',
        AGR: 'Agriculture / Hunting/Forestry/ Animal Farming / Fishing',
        BHS: 'Beauty and Health services (e.g., spa, beauty parlors, fitness centers)',
        BNK: 'Banking',
        BPO: 'Business Process Outsourcing (e.g. Call Centers, Billing/Credit/ Collections, etc.)',
        BRO: 'Brokerage ',
        CHA: 'Charities',
        CMT: 'Commodities Trader ',
        COM: 'Communication (Telecommunications includes postal)',
        CSY: 'Consultancy (e.g. computer-related consultancy-hardware/software, technical-engineering/architectural, scientific-related consultation, business consultancy)',
        CTN: 'Construction (e.g. building, plumbing, electrical, carpentry)',
        EDU: 'Education (including private tutorials, special education)',
        EIC: 'Economically inactive (Not employed or no business)',
        EMB: 'Embassies / Foreign Consulates',
        ENT: 'Entertainment (Recreational / Cultural / Sporting Services (e.g., party planning services, event organizing, carnival rides rental, fireworks displays, media network, film production, etc.)',
        FDI: 'Food Industry / Food Manufacturing/ Food Preparation/ Processing / Food Packaging',
        FIN: 'Financial Services',
        FXD: 'FX Dealer / Money Changer',
        GAC: 'Gaming Clubs / Casino ',
        GOV: 'Government Service-NP',
        INS: 'Insurance Activities',
        LEG: 'Legal Practice',
        LSE: 'Leasing / Rental Activities (e.g. land, building, machinery, etc.)',
        MED: 'Medical Service (includes caregiving)',
        MFG: 'Manufacturing (Non-Food, e.g., garments, vehicles, jewelry, heavy equipment, etc.)',
        MIL: 'Military-NP ',
        MIN: 'Mining',
        MNF: 'Manning or Employment Agencies - Foreign',
        MNL: 'Manning or Employment Agencies - Local',
        NGO: 'NGO / Foundation',
        OPS: 'Other Professional Services (e.g.  Delivery, Photography, Catering, Interior Design, Fashion Design Styling, etc)',
        PUB: 'Publishing / Printing / Reproduction of Recorded Media',
        PWN: 'Pawnshops',
        RCY: 'Recycling',
        REL: 'Real Estate (e.g., development, sales, etc.)',
        REM: 'Remitance Agent',
        REP: 'Repairs Services (e.g., machinery, automobiles, television, cellphone, etc)',
        SAN: 'Sanitation / Cleaning / Housekeeping Services (e.g. janitorial services, building maintenance, laundry,  etc.)',
        SHP: 'Maritime or Shipping',
        TOU: 'Tourism (e.g. Hotels, Inns, Resorts, Tour agencies, Restaurants)',
        TRA: 'Wholesale / Retail Trade',
        TRN: 'Transport (Air, Water or Land)',
        UTL: 'Utilities (Electricity, Gas & Water Supply)',
        WAT: 'Collection, Purification & Distribution of Water',
        OTH: 'OTHERS',
        BLU: 'Banking-Local-Universal/Commercial/Savings',
        BLR: 'Banking-Local-Rural',
        BFB: 'Banking-Foreign Banks',
        PRO: 'Professional Practice'
    }
};
